module.exports = __webpack_public_path__ + "static/media/header-white.eae6beef.png";